import React from "react";

import "./TextDoc.css";

export const TextDoc: React.FunctionComponent<React.PropsWithChildren> = ({
	children
}) => <div className="doc">{children}</div>;
